import React from 'react';
import PropTypes from 'prop-types';

export const OverviewTableRow = ({ children }) => {
    return (
        <tr className="overview-table__row">
            <td className="overview-table__spacer" aria-hidden="true" />
            {children}
            <td className="overview-table__spacer" aria-hidden="true" />
        </tr>
    );
};

OverviewTableRow.propTypes = {
    children: PropTypes.any
};
